import styled from "styled-components";

const colors = {
  error: "#ed6649"
};

export const Input = styled.div`
  > label {
    display: block;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    margin-bottom: 6px;
  }

  > input[type="text"] {
    background-color: white;
    border-radius: 4px;
    border: 1px solid ${(props) => (props.error ? colors.error : "#a0abbb")};
    color: #444;
    padding: 9px;
    width: 100%;

    ::placeholder {
      color: #a0abbb;
    }
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  svg {
    display: flex;
    align-items: center;
    color: #1e22ff;
  }
`;

export const Error = styled.p`
  color: ${colors.error};
  line-height: 1.2;
  margin-left: 3px;
  margin-top: 5px;
`;
